"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoControlDivider = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * VideoControlDivider
 * 
 * An element that seperates video controls inside of a VideoControls component.
 * 
 * @component 
 * @category Molecules
 */
var VideoControlDivider = function VideoControlDivider(props) {
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "VideoControlDivider"
  });
};

exports.VideoControlDivider = VideoControlDivider;